export default __webpack_public_path__ + "static/media/showMenu.18f73156.svg";